"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aSignatureField = exports.aButtonField = exports.anInformationField = exports.aDynamicDropdownField = exports.aCheckboxGroupField = exports.aDropdownField = exports.aRadioField = exports.aMoneyField = exports.aPhoneField = exports.aNumberField = exports.aConsentField = exports.aYearMonthField = exports.aDateField = exports.aTextField = exports.aRepeatableFieldGroup = exports.aFieldGroup = exports.aSubsection = exports.aSection = exports.aSectionGroup = exports.aBlueprint = exports.blueprintBuilderFunctions = void 0;
const uuid_1 = require("uuid");
const fieldTypes_1 = require("../../../types/carrierQuestionnaire/fieldTypes");
const questionnaireBlueprints_1 = require("../../../types/questionnaireBlueprints/questionnaireBlueprints");
const BlueprintBuilderFunctions_1 = require("./BlueprintBuilderFunctions");
const testSeedProviders = {
    forSectionGroup: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'sectionGroupPartName',
        title: { en: 'SectionGroup Title', fr: 'Titre du groupe de sections' },
    }),
    forSection: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'sectionPartName',
        sectionGroupKey: 'insuredPeople',
        title: { en: 'Section Title', fr: 'Titre de la section' },
        subsections: [],
    }),
    forSubsection: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'subsectionPartName',
        title: { en: 'Subsection Title', fr: 'Titre de la sous-section' },
        fieldGroups: [],
    }),
    forFieldGroup: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'fieldGroupPartName',
        title: { en: 'FieldGroup Title', fr: 'Titre du groupe de champs' },
        text: { en: 'FieldGroup Text', fr: 'Texte du groupe de champs' },
        fields: [],
    }),
    forInputField: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'inputFieldPartName',
        title: { en: 'Field Title', fr: 'Titre du champ texte' },
        text: { en: 'Field Text', fr: 'Texte du champ texte' },
        fieldType: fieldTypes_1.FieldTypes.input,
        validateAs: questionnaireBlueprints_1.InputFieldValidations.string,
    }),
    forRadioField: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'radioFieldPartName',
        title: { en: 'Option Field Title', fr: 'Titre du champ option' },
        text: { en: 'Option Field Text', fr: 'Texte du champ option' },
        fieldType: fieldTypes_1.FieldTypes.radio,
        validateAs: questionnaireBlueprints_1.StringFieldValidations.string,
        selectOptions: [{ value: 'id0', text: { en: 'Text', fr: 'Text ' } }],
    }),
    forDropdownField: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'dropdownFieldPartName',
        title: { en: 'Option Field Title', fr: 'Titre du champ option' },
        text: { en: 'Option Field Text', fr: 'Texte du champ option' },
        fieldType: fieldTypes_1.FieldTypes.dropdown,
        validateAs: questionnaireBlueprints_1.StringFieldValidations.string,
        selectOptions: [{ value: 'id0', text: { en: 'Text', fr: 'Text ' } }],
    }),
    forCheckboxField: () => ({
        id: (0, uuid_1.v4)(),
        partName: 'checkboxFieldPartName',
        title: { en: 'Option Field Title', fr: 'Titre du champ option' },
        text: { en: 'Option Field Text', fr: 'Texte du champ option' },
        fieldType: fieldTypes_1.FieldTypes.checkbox,
        validateAs: questionnaireBlueprints_1.BooleanFieldValidations.boolean,
    }),
    forRepeatableFieldGroupOptions: () => ({
        id: (0, uuid_1.v4)(),
        repeatable: {
            repeatableAnswerNodeId: 'missingNodeId',
            minRepeatable: 1,
            maxRepeatable: 3,
            addButtonText: { en: 'Add', fr: 'Ajouter' },
            removeButtonText: { en: 'Remove', fr: 'Supprimer' },
        },
    }),
    forSignatureField: (participantRole) => {
        return {
            id: 'signatureFieldId',
            partName: 'signatureFieldPartName',
            title: { en: 'Field Title', fr: 'Titre du champ texte' },
            text: { en: 'Field Text', fr: 'Texte du champ texte' },
            fieldType: fieldTypes_1.FieldTypes.signature,
            validateAs: questionnaireBlueprints_1.AlwaysValidOptions.signature,
            participantRole,
        };
    },
};
exports.blueprintBuilderFunctions = (0, BlueprintBuilderFunctions_1.generateBlueprintBuilders)(testSeedProviders);
exports.aBlueprint = exports.blueprintBuilderFunctions.aBlueprint;
exports.aSectionGroup = exports.blueprintBuilderFunctions.aSectionGroup;
exports.aSection = exports.blueprintBuilderFunctions.aSection;
exports.aSubsection = exports.blueprintBuilderFunctions.aSubsection;
exports.aFieldGroup = exports.blueprintBuilderFunctions.aFieldGroup;
exports.aRepeatableFieldGroup = exports.blueprintBuilderFunctions.aRepeatableFieldGroup;
exports.aTextField = exports.blueprintBuilderFunctions.aTextField;
exports.aDateField = exports.blueprintBuilderFunctions.aDateField;
exports.aYearMonthField = exports.blueprintBuilderFunctions.aYearMonthField;
exports.aConsentField = exports.blueprintBuilderFunctions.aConsentField;
exports.aNumberField = exports.blueprintBuilderFunctions.aNumberField;
exports.aPhoneField = exports.blueprintBuilderFunctions.aPhoneField;
exports.aMoneyField = exports.blueprintBuilderFunctions.aMoneyField;
exports.aRadioField = exports.blueprintBuilderFunctions.aRadioField;
exports.aDropdownField = exports.blueprintBuilderFunctions.aDropdownField;
exports.aCheckboxGroupField = exports.blueprintBuilderFunctions.aCheckboxGroupField;
exports.aDynamicDropdownField = exports.blueprintBuilderFunctions.aDynamicDropdownField;
exports.anInformationField = exports.blueprintBuilderFunctions.anInformationField;
exports.aButtonField = exports.blueprintBuilderFunctions.aButtonField;
exports.aSignatureField = exports.blueprintBuilderFunctions.aSignatureField;
